import React from 'react';
import { Paper } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import useStyles from './OtherCategories.styles';

const OtherCategoriesSkeleton = props => {
  // eslint-disable-next-line react/prop-types
  const { screen } = props;
  const classes = useStyles();

  if (screen === 'decision')
    return (
      <Paper className={classes.skeletonContainer}>
        <Skeleton className={classes.skeleton} />
        <Skeleton className={classes.skeleton} />
      </Paper>
    );

  return (
    <Paper className={classes.skeletonContainer}>
      <Skeleton className={classes.skeleton} />
      <Skeleton className={classes.skeleton} />
      <Skeleton className={classes.skeleton} />
      <Skeleton className={classes.skeletonLast} />
    </Paper>
  );
};

/*
OtherCategoriesSkeleton.propTypes = {
  screen: Type.oneOf(['main', 'decision']).isRequired,
};
*/

export default OtherCategoriesSkeleton;
